<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:90px !important;">
    </div>
    <div v-show="!dataAlready && !dataFail">Loading....</div>
    <div class="tile is-parent" v-show="dataFail">
      <article class="tile is-child notification is-danger history_tile">
        <div class="content">
            ยังไม่มีประวัติงานซ่อม
        </div>
      </article>
    </div>
    <div class="tile is-parent" v-show="dataAlready">
      <article class="tile is-child notification is-danger history_tile">
        <p class="title" style="font-size:1.5rem;padding-bottom:5px;">ประวัติงานซ่อม</p>
        <div class="content">
            <div class="card">
                <div class="card-content">
                    <div class="media">
                        <div class="media-content">
                            <p class="title is-4">Honda {{model.MTO_NM}}</p>
                            <p class="subtitle is-6">
                                <b>สี</b> {{model.COLOR_NM}} <b>ปี</b> {{model.MODEL_YEAR}}<br>
                                <b>ทะเบียน</b>
                                  <span v-if="model.FRAME_NO==='MRHGK5830MT104026'">1ขบ7023กท</span>
                                  <span v-else>{{model.LICENSE_NO}}</span>
                                <br>
                                <b>เลขตัวถัง</b> {{model.FRAME_NO}}<br>
                            </p>
                        </div>
                    </div>
                    <div class="content">
                        เลือกวันที่ใช้บริการ
                        <div class="select">
                            <select v-model="changeId" @change="changeDate">
                                <option v-for="row in result" v-bind:key="row.RO_NO + Math.random()" :value="row.RO_NO+'|'+row.DLR_CD">{{row.REGISTRATION_DATE}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <span class="updatedAt">Last update Date: {{ updatedAt }}</span>
        </div>
      </article>
    </div>
    <div class="tile is-parent" v-show="dataDetail">
      <article class="tile is-child notification is-danger history_tile">
        <div class="content">
            <div class="tile">
                <div class="tile is-vertical ">
                    <div v-for="(row, index) in detailHead" v-bind:key="index + Math.random()" class="tile is-child box">
                        <p class="title is-5" style="text-align:left">{{row.RQMT_NM}}</p>
                        <table class="table is-bordered is-striped is-fullwidth dataHead">
                            <thead>
                                <tr>
                                    <th>รายละเอียด</th>
                                    <th>รหัสอะไหล่</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(rowDetail, index) in detail[row.RQMT_NO]" v-bind:key="index + Math.random()">
                                    <td>{{rowDetail.DESC_NM}}</td>
                                    <td>{{rowDetail.PARTS_NO}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
      </article>
    </div>
  </div>
</template>
<style scoped>
    .banner {
  background-color: #000;
}
.dataHead {
  font-size: 13px;
}
.dataHead > thead > tr {
  background-color: #eee;
}
.history_tile {
  padding: 1.25rem 1.25rem 1.25rem 1.25rem;
}
.updatedAt {
  font-size: 11px;
}
.notification.is-danger {
  color: #fff;
  background-color: #e00;
}
</style>
<script>
export default {
  name: 'History',
  data: () => ({
    dataAlready: false,
    dataFail: false,
    result: [],
    detail: [],
    detailHead: [],
    model: null,
    frame: '',
    branch: '',
    dataDetail: false,
    lastId: '',
    changeId: '',
    updatedAt: '',
    lastRow: null
  }),
  mounted () {
    let _this = this
    const queryString = decodeURIComponent(decodeURIComponent(window.location.search).replace('?liff.state=', ''))
    const params = new URLSearchParams(queryString)
    _this.frame = params.get('frame')
    _this.branch = params.get('branch')
    const date = new Date()
    date.setDate(date.getDate() - 1)
    _this.updatedAt = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear()
    _this.getDataHead()
  },
  methods: {
    getDataHead () {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getAPI_RR_H?frame=${_this.frame}&branch=${_this.branch}`)
        .then(response => {
          let temp = []
          response.data.map((row) => {
            if (_this.model === null) { _this.model = row }
            if (!temp[row.RO_NO] && (row.GR_FLG === '1' || row.PM_FLG === '1' || row.ACC_FLG === '1')) {
              _this.result.push(row)
              temp[row.RO_NO] = true
            }
            if (_this.lastId === '') {
              _this.lastId = row.RO_NO
              _this.lastRow = row
            }
          })
          if (_this.lastId === '') {
            _this.dataFail = true
          } else {
            _this.dataAlready = true
            _this.getDataDetail(_this.lastId, _this.lastRow.DLR_CD)
          }
        })
    },
    changeDate () {
      const params = this.changeId.split('|')
      this.getDataDetail(params[0], params[1])
    },
    getDataDetail (id, branch) {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getAPI_RR_D?id=${id}&branch=${branch}`)
        .then(response => {
          _this.dataDetail = true
          let temp = []
          let tempDetail = []
          let tempHead = []
          _this.detail = []
          _this.detailHead = []
          response.data.forEach((row) => {
            const rqmtNo = row.RQMT_NO
            if (!tempHead[rqmtNo]) {
              tempHead[rqmtNo] = []
              temp[rqmtNo] = []
              tempDetail[rqmtNo] = []
              _this.detailHead.push(row)
            }
            if (!temp[rqmtNo][row.PARTS_NO]) {
              temp[rqmtNo][row.PARTS_NO] = []
            }
            if (!temp[rqmtNo][row.PARTS_NO][row.DESC_NM] && row.PARTS_NO !== 'LABOR' && row.DESC_NM !== 'ค่าแรง') {
              temp[rqmtNo][row.PARTS_NO][row.DESC_NM] = []
              tempDetail[rqmtNo].push(row)
            }
          })

          _this.detailHead.sort((a, b) => {
            let keyA = new Date(a.RQMT_NO)
            let keyB = new Date(b.RQMT_NO)
            // Compare the 2 dates
            if (keyA < keyB) return -1
            if (keyA > keyB) return 1
            return 0
          })
          _this.detail = tempDetail
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/History.vue